import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

export const getOrganizationPaymentConfirmationConfig = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "organization/payment-confirmation-config",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment confirmation configuration");
};

export const updateOrganizationPaymentConfirmationConfig = async (config) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: "organization/payment-confirmation-config",
    data: config,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update payment confirmation configuration");
};

export const testOrganizationPaymentConfirmationConnection = async () => {
  const envelope = await requestCallCenter({
    method: "post",
    url: "organization/payment-confirmation-config/test-connection",
  });
  return unwrapEnvelopeValue(envelope, "Failed to test payment confirmation connection");
};

export const listPaymentConfirmationEvents = async ({ page = 0, size = 20 } = {}) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "organization/payment-confirmation-config/events",
    params: { page, size },
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment confirmation events");
};

export const getAdminOrganizationPaymentConfirmationConfig = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `admin/organizations/${organizationId}/payment-confirmation-config`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment confirmation configuration");
};

export const updateAdminOrganizationPaymentConfirmationConfig = async (organizationId, config) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `admin/organizations/${organizationId}/payment-confirmation-config`,
    data: config,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update payment confirmation configuration");
};

export const testAdminOrganizationPaymentConfirmationConnection = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: `admin/organizations/${organizationId}/payment-confirmation-config/test-connection`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to test payment confirmation connection");
};
